import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useProductInfo } from 'product/services/productInfo/client'

import { normalizeGetImage } from './normalization'

export const useArticleImage = ({
	articleId,
	colorId,
}: {
	articleId: string
	colorId?: string
}) => {
	const {
		country: { countryISO, languageISO },
	} = useMasterData()

	const { data } = useProductInfo({
		productId: articleId,
		country: countryISO,
		language: languageISO,
		enabled: !!(articleId && colorId),
	})

	if (data && data.colors && colorId) {
		return normalizeGetImage({ product: data, colorId })
	}

	return null
}
